const ColumnHeaderComponent = {
    templateUrl: '/formViewer/component/rowRepeater/header/columnHeader.tpl.html',
    controller: 'columnHeaderController',
    bindings: {
        uiField: '<',
        row: '<',
        timeLastModified: '<',
        rootFormId: '<',
        configurable: '<'
    }
};

angular.module('umFormViewer')
    .component('uiColumnHeader', ColumnHeaderComponent);
